import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M175.2 288.9c-24.31 2.156-46.98 12.2-64.38 29.7-22.4 22.51-32.32 52.9-29.74 82.38 2.254 25.82-16.99 46.1-49.03 46.1C14.34 448 0 462.3 0 480c0 17.7 14.34 32 32.04 32h53.78c54.59 0 133.2-7.568 172.3-46.92 23.67-23.82 32.49-56.36 28.19-87.39L175.2 288.9zM499.5 17.46C490.521 7.18 478.1 1.02 464.49.13c-13.55-1-26.72 3.578-36.92 12.59L222.3 193.7c-6.5 5.7-12.2 12.5-16.6 19.4-9.459 14.95-13.76 31.67-13.78 48.2l110.3 88.18c23.03-5.436 42.71-19.34 55.41-39.44l146.4-231.6c12.17-18.95 10.17-44.04-4.53-60.98z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }